import React from "react";
import SingleOTPInput from "../SingleInput/SingleInput";
import { Box, makeStyles, Typography } from "@material-ui/core";
import { useOtpInput } from "./state/useOtpInputState";
import { Translate as T } from "react-localize-redux";
var useStyle = makeStyles({
    textInvalid: {
        color: "#AD0C2A",
        fontSize: "12.8px",
        marginLeft: "8px",
        marginTop: "8.8px",
    },
});
export var OtpInput = function (props) {
    var classes = useStyle();
    var length = props.length, autoFocus = props.autoFocus, disabled = props.disabled, inputClassName = props.inputClassName, isInvalid = props.isInvalid;
    var _a = useOtpInput(props), activeInput = _a.activeInput, otpValues = _a.otpValues, handleOnFocus = _a.handleOnFocus, handleOnChange = _a.handleOnChange, handleOnKeyDown = _a.handleOnKeyDown, onBlur = _a.onBlur;
    var inputBorder = isInvalid ? "1px solid #9F242F" : "1px solid #CBD5E0";
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { display: "flex" }, Array(length)
            .fill("")
            .map(function (_, index) { return (React.createElement(SingleOTPInput, { key: "SingleInput-" + index, focus: activeInput === index, value: otpValues && otpValues[index], autoFocus: autoFocus, onFocus: handleOnFocus(index), onChange: handleOnChange, onKeyDown: handleOnKeyDown, onBlur: onBlur, style: {
                border: inputBorder,
            }, className: inputClassName, disabled: disabled })); })),
        isInvalid && (React.createElement(Typography, { className: classes.textInvalid },
            React.createElement(T, { id: "otpTextVerification.invalidCode" })))));
};
